'use strict';

module.exports = {
  'PER_PERSON': 'Per Person',
  'PER_CAR': 'Per Car',
  'PER_BOTTLE': 'Per Bottle',
  'PER_ITEM': 'Per Item',
  'FLAT': 'Flat',
  'FREE': 'Free'
};